import request from '@/utils/request';
/**获取字典类型和使用角色 */
export function getTypeRole() {
  return request.post('admin/dictionary/get-type-role', {});
}
/**字典列表 */
export function dictionaryList(data) {
  return request.post('admin/dictionary/list', data);
}
/**字典详情 */
export function dictionarydDtail(data) {
  return request.post('admin/dictionary/detail', data);
}
/**字典新增 */
export function addDictionaryd(data) {
  return request.post('admin/dictionary/store', data);
}
/**字典编辑 */
export function editDictionaryd(data) {
  return request.post('admin/dictionary/edit', data);
}